import FilterTagsDropdown from './js/FilterTagsDropdown';
export default FilterTagsDropdown;
